export default __webpack_public_path__ + "images/26deedacbfdd67f8b67ef0a7746e47a3-seminar.jpg";